import { motion } from "framer-motion";

const SocialLinks = () => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.5 }}
      className="flex justify-center space-x-4 mt-8"
    >
      <a href="https://github.com/sertacgltkn" className="text-white text-lg hover:text-gray-400">
        GitHub
      </a>
      <a href="https://twitter.com/sertacgltkn" className="text-white text-lg hover:text-gray-400">
        Twitter
      </a>
      <a href="https://www.linkedin.com/in/sertacgultekin/" className="text-white text-lg hover:text-gray-400">
        LinkedIn
      </a>
    </motion.div>
  );
};

export default SocialLinks;
